// cms - file system
export const FS_OBJECT_LOAD_ERROR = 'FS_OBJECT_LOAD_ERROR'
export const FS_OBJECT_LOAD_SUCCESS = 'FS_OBJECT_LOAD_SUCCESS'

export const FS_RENAME_OBJECT_SUCCESS = 'FS_RENAME_OBJECT_SUCCESS'
